import { ArpMediaType, KeyAndScale } from '@arpeggi/shared'
import { formatTime } from '../../../__legacy__/components/player/PlayerUtils'
import {
  SAMPLE_OPENSEA_BASE_URL,
  SONG_OPENSEA_BASE_URL,
  STEM_OPENSEA_BASE_URL
} from '../../../__legacy__/utils/media'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { useFormattedDate } from './useFormattedDate'

const getOpenSeaLink = (media: IArpMedia) => {
  let baseURL = SONG_OPENSEA_BASE_URL
  if (media.type === ArpMediaType.STEM) baseURL = STEM_OPENSEA_BASE_URL
  if (media.type === ArpMediaType.SAMPLE) baseURL = SAMPLE_OPENSEA_BASE_URL
  return `${baseURL}/${media.tokenId}`
}

type TableData = { key: string; value: string }[]

const getArpMediaDetails = ({ metadata, type, durationMs }: IArpMedia) => {
  const { key, bpm, tags, genres } = metadata
  const duration = durationMs ? formatTime(durationMs / 1000) : 'Unknown'
  const tableData: TableData = []
  if (type === ArpMediaType.SAMPLE || type === ArpMediaType.STEM)
    tableData.push({ key: 'Instrument', value: tags.join(', ') })
  tableData.push({ key: 'Key', value: KeyAndScale.from(key).displayName() })
  tableData.push({ key: 'BPM', value: bpm.toString() })
  tableData.push({ key: 'Duration', value: duration })
  if (type === ArpMediaType.SONG) tableData.push({ key: 'Genre', value: genres.join(', ') })
  return tableData
}

const getArpTokenDetails = (media: IArpMedia) => {
  const { mintedAt, tokenId, contractAddress } = media
  const tableData: TableData = []
  tableData.push({ key: 'Token ID', value: tokenId.toString() })
  tableData.push({ key: 'Date Minted', value: useFormattedDate(mintedAt) })
  tableData.push({ key: 'Blockchain', value: 'Polygon' })
  return tableData
}

export const useArpDetails = (media: IArpMedia) => {
  return {
    mediaTableData: getArpMediaDetails(media),
    openSeaLink: getOpenSeaLink(media),
    tokenTableData: getArpTokenDetails(media),
    contractAddressDisplay: media.contractAddress.substring(0, 9) + '...',
    contractLink: `https://polygonscan.com/address/${media.contractAddress}`
  }
}
